<div class="flex flex-col gap-3">

	<div class="w-full flex justify-between items-start">
		<div class="cursor-pointer iteminner" (click)="navigate(product)">
			<img src="{{product.customization.customProduct ? product.customization.customProduct!.heroImage : product.customization.fabricProductPreview!.product.heroImage}}"
				 class="rounded-md"
				 alt=""/>
		</div>
		<div class=" w-full flex md:hidden flex-col justify-between items-stretch">
			<div class="inter_info_cont w-full">
				<p class="item_name"
				   [innerHTML]="(product.customization.customProduct ? product.customization.customProduct.name : product.customization.fabricProductPreview!.product.name)  | truncketHtml:40">
				</p>
				<p class="price">{{ product.currency | uppercase }} {{ product.price | number: '1.0-2' }} | {{ product.quantity }} {{ product.unit }}</p>
			</div>
		</div>
		<div class="md:max-w-[64%] w-full hidden md:flex flex-col justify-between items-stretch">
			<div class="flex justify-between items-start w-full">
				<div class="inter_info_cont ">
					<p class="item_name"
					   [innerHTML]="(product.customization.customProduct ? product.customization.customProduct.name : product.customization.fabricProductPreview!.product.name)  | truncketHtml:40">
					</p>
					<p class="price">{{ product.currency | uppercase }} {{ product.price | number: '1.0-2' }} | {{ product.quantity }} {{ product.unit }}</p>
				</div>
			</div>
			<div *ngIf="product.hasWorkflow" class="w-full">
				<fb-custom-order-item-process-overview *ngIf="!loading"
												[product]="product"
												[orderId]="orderId"
												[orderItemId]="orderItemId"
												(emitMoreUpdatesToggle)="onViewProcessUpdates($event)"
												[workflow]="orderItemWorkflow"></fb-custom-order-item-process-overview>
			</div>
		</div>

	</div>
	<div *ngIf="product.hasWorkflow" class="md:hidden w-full">
		<fb-custom-order-item-process-overview *ngIf="!loading"
										[product]="product"
										[orderId]="orderId"
										[orderItemId]="orderItemId"
										(emitMoreUpdatesToggle)="onViewProcessUpdates($event)"
										[workflow]="orderItemWorkflow"></fb-custom-order-item-process-overview>
	</div>

</div>
<fb-custom-order-item-process-status *ngIf="showProcess"
							  [id]="orderItemId + '-feedback'"
							  [product]="product"
							  [orderId]="orderId"
							  [workflow]="orderItemWorkflow"></fb-custom-order-item-process-status>

